<template>
  <v-card>
    <v-card-title>{{$tf('Contact')}}</v-card-title>
    <v-card-text>
  <v-form action="javascript:void(0);" method="post" ref="form" id="contact-form">
    <v-container class="pa-0" >
      <v-row wrap>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            name="firstname"
            :label="$tf('Firstname')"
            required
            v-model="firstname"
            :rules="validationFormRule('firstname')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            name="lastname"
            :label="$tf('Lastname')"
            required
            v-model="lastname"
            :rules="validationFormRule('lastname')"

          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            name="email"
            label="Email"
            required
            v-model="email"
            id="email"
            :rules="validationFormRule('email')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            name="message"
            :label="$tf('Your message')"
            required
            v-model="message"
            multi-line
            :rules="validationFormRule('message')"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="text--lighten-5 cancel"
        text
        @click="$root.$emit('closeDialog')">{{$tf('Cancel')}}</v-btn>
      <v-btn
        class="primary"
        dark
        @click="accept">{{$tf('Send')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import validation from '../../mixins/validation'
export default {

  name: 'contact-form',
  mixins: [validation],
  props: {
    submit: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultEmail: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      firstname: '',
      lastname: '',
      email: '',
      message: ''
    }
  },
  methods: {
    cancel () {},
    accept () {
      if (this.$refs.form.validate()) {
        this.$axios.post('https://us-central1-idonia-public.cloudfunctions.net/idonia-ui-troubleshoot-function-sendmail', {
          'name': this.firstname + ' ' + this.lastname,
          'email': this.email,
          'message': this.message }
        ).then((response) => {
          if (response.status === 200) {
            this.$root.$emit('supportSuccess')
            this.$refs.form.reset()
          } else {
            this.$root.$emit('supportError', response.data)
          }
        }).catch((e) => {
          this.$root.$emit('supportError', e)
        }).finally(() => {
          this.$root.$emit('closeDialog')
        })
      }
    }
  }
}

</script>

<style>
  #contact-form .input-group--required label:after {
    padding-left: 5px;
    color: red;
  }
</style>
